export const entityTableHeader = [
  { title: 'Name', align: 'start', key: 'name', sortable: false },
  { title: 'Country', align: 'start', key: 'countryCode', sortable: false },
  { title: 'Reference', align: 'start', key: 'reference', sortable: false },
  { title: 'Enabled', align: 'start', key: 'enabled', sortable: false },
  { title: 'View', align: 'start', key: 'actions', sortable: false },
];
